// Offer Constants
export const SHORT_DESCRIPTION_MAX_LENGTH = 75;
export const LONG_DESCRIPTION_MAX_LENGTH = 250;
export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB in bytes
export const FORM_SUBMISSION_ERROR =
  "An error occurred. Please check the form for errors and try again.";

export const PREFERRED_LANGS = [
  { name: "English", value: "en" },
  { name: "French", value: "fr" },
];

export const LANG_CODES_KEYS = {
  i18nLang: "i18nLang",
  i18nLangSAdmin: "i18nLangSAdmin",
};

export const AppValues = {
  multilingual: "multilingual",
  hilo: "HILO",
  okkto: "OKKTO",
  okktoRequestHeader: { "app-name": "okkto-application" },
};

export const TenantValues = [
  { name: "HILO", value: "2" },
  { name: "OKKTO", value: "1" },
  { name: "CSQ", value: "3" },
];

export const ValidImageFileTypes = ["jpg", "jpeg", "png", "gif", "bmp", "ico"];

export const TARGET_PREFIXES = {
  event: "event:",
  group: "group:",
};
